import styled from "styled-components";
import { theme } from "../../../theme";

export const PaginationTableContainer = styled.div`
  border-radius: 8px;
  overflow: hidden;
`;

export const TableBody = styled.div`
  background-color: white;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  padding: 24px;
`;

export const AdditionalButtonWrapper = styled.div`
  margin-right: 8px;
  margin-left: 24px;
`;
export const TotalCount = styled.span`
  color: ${theme.colors.gray1};
  ${theme.typo.heading.b14};
`;
export const DeleteWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
`;

export const TableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 16px 24px;
  box-shadow: 0px -1px 0px 0px #e2e2e2 inset;
  background-color: white;
  max-height: 60px;
`;
export const TableFooter = styled(TableHeader)`
  min-height: 32px;
  padding: 31px 44px 44px 48px;
`;
export const TextPlace = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: #242426;
`;
export const ButtonWrap = styled.div`
  display: flex;

  justify-content: flex-end;
`;

export const HeaderButtonWrap = styled.div`
  display: flex;
  gap: 0 12px;
`;
